
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import isArray from 'lodash/isArray';

import { IfComp } from '../../../core';

import getAttributeValueAsText from '../getAttributeValueAsText';

import ObjectDetailAttributeGeneric from './ObjectDetailAttributeGeneric';

const ObjectDetailAttributeHover = ({attribute, dataModel, value}) => {

    const classNames = mergeStyleSets({
        value: {
            width: 150,
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            color: '#0078d4'
        },
        valueContainer: {
            position: 'relative'
        },
        hoverContent: {
            position: 'absolute',
            top: 20
        }
    });

    const [hover, setHover] = React.useState(false);

    const processedValue = getAttributeValueAsText(attribute, value);

    const getHoverHtmlContent = () => {
        let htmlContent = attribute.visualize.htmlContent;
        if (isArray(htmlContent)) {
            htmlContent = htmlContent.join(' ');
        }
        htmlContent = htmlContent.replace(/@VALUE@/g, value);
        htmlContent = htmlContent.replace(/@PROCESSED_VALUE@/g, processedValue);
        return htmlContent;
    }

    const handleMouseEnter = () => {
        setHover(true);
    }

    const handleMouseLeave = () => {
        setHover(false);
    }

    const valueComponent = (
        <Stack className={classNames.valueContainer}>
            <Stack horizontal
                className={classNames.value}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            >
                <Stack.Item grow>{processedValue}</Stack.Item>
            </Stack>
            <IfComp cond={hover}>
                <div className={classNames.hoverContent}>
                    <div dangerouslySetInnerHTML={{__html: getHoverHtmlContent()}}></div>
                </div>
            </IfComp>
        </Stack>
    );

    return (
        <ObjectDetailAttributeGeneric
            attribute={attribute}
            dataModel={dataModel}
            value={value}
            valueComponent={valueComponent}
        />
    );
}

export default ObjectDetailAttributeHover;
